import logoCreek from "../../common/assets/logoCreek.png";
import logoNuevamente from "../../common/assets/logoNuevamente.png";
import logoHangover from "../../common/assets/logoHangover.png";
import logoLeparc from "../../common/assets/logoLeparc.png";
import logoKeops from "../../common/assets/logoKeops.png";
import logoQuickpass from "../../common/assets/logoQuickpass.png";
import logoRosario from "../../common/assets/logoRosario.png";
import logoWabi from "../../common/assets/logoWabi.png";
import logoRoof from "../../common/assets/logoRoof.png";
import logoEventclub from "../../common/assets/logoEventclub.png";
import logoFruta from "../../common/assets/logoFruta.png";
import logoBarto from "../../common/assets/logoBarto.png";
import logoCircus from "../../common/assets/logoCircus.png";
import logoFendy from "../../common/assets/logoFendy.png";
import logoCruz from "../../common/assets/logoCruz.png";
//import logoLeparc from "../../common/assets/logoLeparc.png";


let logo = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    logo = logoCreek;
}else if (tenantId == "nuevamente") {
    logo = logoNuevamente;
}else if (tenantId == "leparc") {
    logo = logoLeparc;
}else if (tenantId == "hangover") {
    logo = logoHangover;
}else if (tenantId == "keops") {
    logo = logoKeops;
}else if (tenantId == "quickpass") {
    logo = logoQuickpass;
}else if (tenantId == "rosario") {
    logo = logoRosario;
}else if (tenantId == "wabi") {
    logo = logoWabi;
}else if (tenantId == "roof") {
    logo = logoRoof;
}else if (tenantId == "evtclub") {
    logo = logoEventclub;
}else if (tenantId == "fruta") {
    logo = logoFruta;
}else if (tenantId == "barto") {
    logo = logoBarto;
}else if (tenantId == "circus") {
    logo = logoCircus;
}else if (tenantId == "fendy") {
    logo = logoFendy;
}else if (tenantId == "cruz") {
    logo = logoCruz;
}


export default logo;


// WEBPACK FOOTER //
// ./src/components/Header/LogoHeader.js